import {
  Checkbox as MuiCheckbox,
  FormControl,
  FormHelperText,
  FormControlLabel,
  Stack,
} from "@mui/material";
import { forwardRef, useEffect, useState } from "react";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import IndeterminateCheckBox from "@mui/icons-material/IndeterminateCheckBox";

const CHECKBOX_STATES = {
  Checked: true,
  Indeterminate: null,
  Empty: false,
};

export const Checkbox = forwardRef(
  ({ label, onChange, value, error, helperText, nullable, ...props }, ref) => {
    const [status, setStatus] = useState(undefined);

    useEffect(() => {
      setStatus(nullable ? value : Boolean(value));
    }, [value, nullable]);

    const handleClickNullable = () => {
      if (status === CHECKBOX_STATES.Checked) {
        setStatus(CHECKBOX_STATES.Empty);
      } else if (status === CHECKBOX_STATES.Empty) {
        setStatus(CHECKBOX_STATES.Indeterminate);
      } else {
        setStatus(CHECKBOX_STATES.Checked);
      }
    };

    const handleClickNonNullable = () => {
      if (status === CHECKBOX_STATES.Checked) {
        setStatus(CHECKBOX_STATES.Empty);
      } else {
        setStatus(CHECKBOX_STATES.Checked);
      }
    };

    const handleClick = () => {
      if (nullable) handleClickNullable();
      else handleClickNonNullable();
    };

    useEffect(() => {
      status !== undefined && onChange && onChange(status);
    }, [status]);

    if (status === undefined) return <></>;

    return (
      <FormControl error={error}>
        <FormControlLabel
          label={label}
          control={
            <MuiCheckbox
              {...props}
              ref={ref}
              onChange={handleClick}
              checked={status === CHECKBOX_STATES.Checked}
              indeterminate={status === CHECKBOX_STATES.Indeterminate}
            />
          }
          sx={{ marginLeft: 0, justifyContent: "space-between" }}
          labelPlacement="start"
        />
        {helperText && (
          <FormHelperText id="my-helper-text">{helperText}</FormHelperText>
        )}
      </FormControl>
    );
  },
);

export const NullableCheckbox = forwardRef((props, ref) => (
  <Checkbox {...props} nullable ref={ref} />
));

export const ViewCheckbox = ({ label, value, ...props }) => {
  return (
    <Stack direction="row" alignItems="center" gap={1}>
      <>
        {value ? <CheckBoxIcon /> : <></>}
        {value === false ? <CheckBoxOutlineBlankIcon /> : <></>}
        {value === null || value === undefined ? (
          <IndeterminateCheckBox />
        ) : (
          <></>
        )}
      </>
      {label}
    </Stack>
  );
};

export default Checkbox;
